import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/client/src/components/CategoryPageLayout/CategoryPageLayout.tsx");
